<app-hr-page-header
  [heading]="headingDepartment"
  [searchPlaceholder]="'Search departments'"
  [addButtonText]="'Add Department'"
  [exportButtonText]="'Export'"
  [showFilterIcon]="true"
  [initialSearchQuery]="searchQuery"
  (searchInput)="onSearchInput($event)"
  (searchFocus)="openFilterDialog()"
  (filterClick)="openFilterDialog()"
  (addClick)="addDepartment()"
  (exportClick)="exportDepartments()"
></app-hr-page-header>

<div class="hr-table-container">
  <div class="table-responsive">
    <table class="table" id="dept_table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Department Name</th>
          <th>Business</th>
          <th>Head</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let dept of departmentlist; let i = index">
          <td>{{ dept?.id }}</td>
          <td>{{ dept?.name | titlecase }}</td>
          <td>{{ dept?.business?.name || dept?.business_name || dept?.business }}</td>
          <td>{{ dept?.head?.name || dept?.head?.emp_id }}</td>
          <td>
            <span class="action-link" (click)="editDept(dept)">
              Edit
              
              <!-- <img class="arrow-image" src="../../../assets/images/arrows.svg" alt="">
             -->
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <!-- <div class="page_div" *ngIf="departmentlist?.length > 0">
    <div class="row" id="pagination-container">
      <div class="col-sm-6 float-left">
        Current Page {{ currentPage }} of {{ totalPages }} ({{ totalCount }} total departments)
      </div>
      <div class="col-sm-6">
        <div class="float-end">
          <button
            (click)="previousPage()"
            class="btn btn-primary"
            [disabled]="currentPage === 1"
          >
            &lt;&lt;
          </button>
          <button
            (click)="firstPage()"
            class="btn btn-primary"
            [disabled]="currentPage === 1"
          >
            First
          </button>
          <ng-container *ngIf="totalPages > 0">
            <button
              *ngFor="let page of getNumericButtons()"
              (click)="gotoPage(page)"
              class="btn btn-primary"
              [class.active]="page === currentPage"
            >
              {{ page }}
            </button>
          </ng-container>
          <button
            (click)="lastPage()"
            class="btn btn-primary"
            [disabled]="currentPage === totalPages"
          >
            Last
          </button>
          <button
            (click)="nextPage()"
            class="btn btn-primary"
            [disabled]="currentPage === totalPages"
          >
            &gt;&gt;
          </button>
        </div>
      </div>
    </div>
  </div> -->

  <!-- No data message -->
  <div class="no-data-wrapper" *ngIf="!departmentlist || departmentlist.length === 0">
    <img src="/assets/images/no-data.svg" alt="No data" class="no-data-img">
    <p>No departments found</p>
  </div>
</div>
